<template>
  <div>
    <div>
      <div v-if="loaded && apiTokens.length === 0">
        <div class="alert alert-primary" role="alert">
          توکنی یافت نشد، برای استفاده از وب سرویس میرول یک توکن بسازید.
        </div>
      </div>
    </div>
    <div v-if="loaded && apiTokens.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-fixed"
          >
            <thead>
              <tr>
                <th class="w-auto">عنوان</th>
                <th class="w-40">توکن</th>
                <th class="w-20">تاریخ</th>
                <th class="w-auto"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="apiToken in apiTokens" :key="apiToken.id">
                <td>{{ apiToken.name }}</td>
                <td dir="ltr" class="text-wrap">{{ apiToken.token }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(apiToken.updated_at) }}
                </td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(apiToken.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                  <button
                    class="btn btn-xs btn-outline-primary mr-1"
                    @click="saveToClipboard(apiToken.token, $event)"
                  >
                    <i class="flaticon2-copy"></i>
                    کپی
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_API_TOKENS,
  STORE_API_TOKEN,
  DESTROY_API_TOKEN
} from "@/core/services/store/tokens.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "api-tokens",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "توکن ها" }]);
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: '<i class="flaticon2-plus"></i>توکن جدید',
          event: "save-api-token-event",
          class: "btn-primary",
          id: "save-api-token-event-btn"
        }
      ]
    });
    this.eventHub.$on("save-api-token-event", this.save);

    this.loaded = false;
    this.updateTokens();
  },
  beforeDestroy() {
    this.eventHub.$off("save-api-token-event");
    document.getElementById("save-api-token-event-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["apiTokens"])
  },
  methods: {
    updateTokens() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_API_TOKENS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    save() {
      let btn = document.getElementById("save-api-token-event-btn");

      Swal.fire({
        text: "عنوان توکن را وارد کنید.",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        cancelButtonText: "انصراف",
        cancelButtonColor: "#ed1c24",
        confirmButtonText: "ساخت",
        confirmButtonColor: "#4554a0",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.isConfirmed) {
          this.disableBtn(btn);

          this.$store
            .dispatch(STORE_API_TOKEN, {
              name: result.value
            })
            .then(() => {
              this.enableBtn(btn);
              this.updateTokens();
            })
            .catch(() => {
              this.enableBtn(btn);
            });
        }
      });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف توکن اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_API_TOKEN, id).then(() => {
            this.updateTokens();
          });
        }
      });
    },
    saveToClipboard(text, event) {
      event.target.disabled = true;
      event.target.blur();
      setTimeout(function() {
        event.target.disabled = false;
      }, 1000);

      navigator.clipboard.writeText(text);
    }
  }
};
</script>
